"use strict";
// noinspection JSUnusedGlobalSymbols
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hooks = void 0;
var Chartisan_1 = require("./Chartisan");
var Hooks = /** @class */ (function (_super) {
    __extends(Hooks, _super);
    function Hooks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Used to set the color of a dataset.
     */
    Hooks.prototype.colors = function (colors) {
        if (colors === void 0) { colors = Chartisan_1.colorPalette; }
        return this.custom(function (_a) {
            var _b;
            var data = _a.data;
            if ((_b = data.data) === null || _b === void 0 ? void 0 : _b.datasets)
                data.data.datasets = data.data.datasets.map(function (dataset, index) { return (__assign(__assign({}, dataset), { backgroundColor: colors[index % colors.length] })); });
            return data;
        });
    };
    /**
     * Set the pie border colors of the datasets.
     */
    Hooks.prototype.borderColors = function (colors) {
        if (colors === void 0) { colors = Chartisan_1.colorPalette; }
        return this.custom(function (_a) {
            var _b;
            var data = _a.data;
            if ((_b = data.data) === null || _b === void 0 ? void 0 : _b.datasets)
                data.data.datasets = data.data.datasets.map(function (dataset, index) { return (__assign(__assign({}, dataset), { borderColor: colors[index % colors.length] })); });
            return data;
        });
    };
    /**
     * Set the pie colors of the datasets.
     */
    Hooks.prototype.pieColors = function (colors) {
        if (colors === void 0) { colors = Chartisan_1.colorPalette; }
        return this.custom(function (_a) {
            var _b;
            var data = _a.data;
            if ((_b = data.data) === null || _b === void 0 ? void 0 : _b.datasets) {
                data.data.datasets = data.data.datasets.map(function (dataset, _, array) {
                    var _a, _b;
                    var d = new Array((_b = (_a = dataset.data) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : array === null || array === void 0 ? void 0 : array.length).fill('');
                    return __assign(__assign({}, dataset), { 
                        // borderColor: d.map((_, i) => colors[i % colors.length]),
                        backgroundColor: d.map(function (_, i) { return colors[i % colors.length]; }) });
                });
            }
            return data;
        });
    };
    /**
     * Set the pie border colors of the datasets.
     */
    Hooks.prototype.pieBorderColors = function (colors) {
        if (colors === void 0) { colors = Chartisan_1.colorPalette; }
        return this.custom(function (_a) {
            var _b;
            var data = _a.data;
            if ((_b = data.data) === null || _b === void 0 ? void 0 : _b.datasets) {
                data.data.datasets = data.data.datasets.map(function (dataset, _, array) {
                    var _a, _b;
                    var d = new Array((_b = (_a = dataset.data) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : array === null || array === void 0 ? void 0 : array.length).fill('');
                    return __assign(__assign({}, dataset), { borderColor: d.map(function (_, i) { return colors[i % colors.length]; }) });
                });
            }
            return data;
        });
    };
    /**
     * Used to make the chart responsive.
     */
    Hooks.prototype.responsive = function (value) {
        if (value === void 0) { value = true; }
        return this.options({ options: { maintainAspectRatio: !value } });
    };
    /**
     * Set the chart legend options. If a boolean is
     * supplied, it will be used as the display value.
     */
    Hooks.prototype.legend = function (legend) {
        if (legend === void 0) { legend = {}; }
        if (typeof legend === 'boolean')
            legend = { display: legend };
        return this.options({ options: { legend: legend } });
    };
    /**
     * Determines if the chart will show the axes.
     */
    Hooks.prototype.displayAxes = function (display, strict) {
        if (display === void 0) { display = true; }
        if (strict === void 0) { strict = false; }
        return this.options(strict
            ? { options: { scale: { display: display } } }
            : {
                options: {
                    scales: { xAxes: [{ display: display }], yAxes: [{ display: display }] },
                },
            });
    };
    /**
     * Creates a minimalist chart.
     */
    Hooks.prototype.minimalist = function (value) {
        if (value === void 0) { value = true; }
        this.legend({ display: !value });
        return this.displayAxes(!value);
    };
    /**
     * Determines the padding of the chart.
     */
    Hooks.prototype.padding = function (padding) {
        if (padding === void 0) { padding = 5; }
        return this.options({ options: { layout: { padding: padding } } });
    };
    /**
     * Set the dataset options. If a single string is provided, all the datasets
     * will be specified to the desired type. If an array is provided, if the
     * inner element is a string, it will be used as a type, otherwise, the options
     * will be applied, in both cases, to the nth position. Keep in mind that if the
     * array length is less than the datasets, it will start from the start again.
     */
    Hooks.prototype.datasets = function (types, general) {
        if (general === void 0) { general = 'bar'; }
        return this.custom(function (_a) {
            var _b;
            var data = _a.data;
            data.type = typeof types === 'string' ? types : general;
            if (Array.isArray(types) && ((_b = data.data) === null || _b === void 0 ? void 0 : _b.datasets)) {
                var t_1 = types.map(function (e) { return (typeof e === 'string' ? { type: e } : e); });
                data.data.datasets = data.data.datasets.map(function (dataset, index) { return (__assign(__assign({}, dataset), t_1[index % t_1.length])); });
            }
            return data;
        });
    };
    /**
     * Sets a title to the chart.
     */
    Hooks.prototype.title = function (title) {
        if (title === void 0) { title = {}; }
        return this.options({
            options: {
                title: typeof title === 'string' ? { text: title, display: true } : __assign({ display: true }, title),
            },
        });
    };
    /**
     * Set the chart to begin at zero.
     */
    Hooks.prototype.beginAtZero = function (beginAtZero, axe) {
        var _a;
        if (beginAtZero === void 0) { beginAtZero = true; }
        if (axe === void 0) { axe = 'y'; }
        return this.options({
            options: { scales: (_a = {}, _a["".concat(axe, "Axes")] = [{ ticks: { beginAtZero: beginAtZero } }], _a) },
        });
    };
    /**
     * Set the chart to begin at zero.
     */
    Hooks.prototype.precision = function (precision, axe) {
        var _a;
        if (axe === void 0) { axe = 'y'; }
        return this.options({
            options: { scales: (_a = {}, _a["".concat(axe, "Axes")] = [{ ticks: { precision: precision } }], _a) },
        });
    };
    /**
     * Set the chart to begin at zero.
     */
    Hooks.prototype.stepSize = function (stepSize, axe) {
        var _a;
        if (axe === void 0) { axe = 'y'; }
        return this.options({
            options: { scales: (_a = {}, _a["".concat(axe, "Axes")] = [{ ticks: { stepSize: stepSize } }], _a) },
        });
    };
    /**
     * Sets the tooltip options for the chart.
     */
    Hooks.prototype.tooltip = function (tooltips) {
        if (typeof tooltips === 'boolean')
            tooltips = { enabled: tooltips };
        return this.options({ options: { tooltips: tooltips } });
    };
    /**
     * Sometimes you need a very complex legend. In these cases,
     * it makes sense to generate an HTML legend. Charts provide
     * a generateLegend() method on their prototype that returns an
     * HTML string for the legend. To configure how this legend
     * is generated, you can change the legendCallback config property.
     */
    Hooks.prototype.legendCallback = function (legendCallback) {
        return this.options({ options: { legendCallback: legendCallback } });
    };
    /**
     * Configures the animations of chart.js.
     */
    Hooks.prototype.animation = function (animation) {
        return this.options({ options: { animation: animation } });
    };
    return Hooks;
}(Chartisan_1.Hooks));
exports.Hooks = Hooks;
